var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.activeZones),function(zone){return _c('MglGeojsonLayer',{key:zone.type,attrs:{"sourceId":'zone-source-' + zone.type,"source":zone.geojson,"layerId":zone.fillLayer.id,"layer":zone.fillLayer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }